// "(English and French)"-style suffix for a cert's CMS `languages` codes ('en', 'fr', ...),
// translated into the site locale by the platform's Intl data. Empty when none are set.
export const languageLabel = (languages: string[] | undefined, locale: string): string => {
  const codes = (languages ?? []).filter(Boolean);
  if (!codes.length) return '';
  const names = new Intl.DisplayNames([locale], { type: 'language' });
  const list = codes.map(code => {
    const name = names.of(code) ?? code;
    return name.charAt(0).toLocaleUpperCase(locale) + name.slice(1);
  });
  return `(${new Intl.ListFormat(locale, { type: 'conjunction' }).format(list)})`;
};

export type CertFile = { link?: string; languages?: string[] };

// A location cert's downloadable files: the nested `files` group, else the group's older single link/languages.
export const certFiles = (g: { link?: string; languages?: string[]; files?: CertFile[] }): CertFile[] => {
  const files = (g.files ?? []).filter(f => f.link);
  return files.length ? files : g.link ? [{ link: g.link, languages: g.languages }] : [];
};
